var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarToggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.91667V17.0833M2.5 7.83333C2.5 5.96667 2.5 5.03333 2.86333 4.32C3.18291 3.69282 3.69282 3.18291 4.32 2.86333C5.03333 2.5 5.96667 2.5 7.83333 2.5H12.1667C14.0333 2.5 14.9667 2.5 15.68 2.86333C16.3072 3.18291 16.8171 3.69282 17.1367 4.32C17.5 5.03333 17.5 5.96667 17.5 7.83333V12.1667C17.5 14.0333 17.5 14.9667 17.1367 15.68C16.8171 16.3072 16.3072 16.8171 15.68 17.1367C14.9667 17.5 14.0333 17.5 12.1667 17.5H7.83333C5.96667 17.5 5.03333 17.5 4.32 17.1367C3.69282 16.8171 3.18291 16.3072 2.86333 15.68C2.5 14.9667 2.5 14.0333 2.5 12.1667V7.83333Z",
    stroke: "#5C6777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.91667V17.0833M2.5 7.83333C2.5 5.96667 2.5 5.03333 2.86333 4.32C3.18291 3.69282 3.69282 3.18291 4.32 2.86333C5.03333 2.5 5.96667 2.5 7.83333 2.5H12.1667C14.0333 2.5 14.9667 2.5 15.68 2.86333C16.3072 3.18291 16.8171 3.69282 17.1367 4.32C17.5 5.03333 17.5 5.96667 17.5 7.83333V12.1667C17.5 14.0333 17.5 14.9667 17.1367 15.68C16.8171 16.3072 16.3072 16.8171 15.68 17.1367C14.9667 17.5 14.0333 17.5 12.1667 17.5H7.83333C5.96667 17.5 5.03333 17.5 4.32 17.1367C3.69282 16.8171 3.18291 16.3072 2.86333 15.68C2.5 14.9667 2.5 14.0333 2.5 12.1667V7.83333Z",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarToggle);
export default __webpack_public_path__ + "static/media/sidebar-toggle.c26a9c0a.svg";
export { ForwardRef as ReactComponent };